<template>
    <div class="clearfix rounded pb-5 mx-auto">
        <h4 class="atlhr-dashboard-title mt-10 px-0 mb-0">GF Settlement Policy Settings<span>
            <a v-bind:href="$api_url+'/company/dashboard'">Dashboard</a> / Settings / GF Process Settings / GF Settlement Policy Settings</span>
        </h4>

        <div class="ibox mt-4">
            <div class="ibox-content">

                <div v-if="$acl['company/savegfsettings'] > 0" id="gf_settlement_policy_settings">
                    <div class="clearfix row no-margin">
                        <div class="col-md-12 fixed-section-one mb-4">
                            <div class="clearfix approval-container row">
                                <div class="col-4 approve-level-label">
                                    <div class="approve-level-title">
                                        GF Reasons for Separation List
                                    </div>
                                    <div class="approve-level-description">
                                        The GF Settlement Policy Settings defines Reasons for which Members may be leaving the Gratuity Fund and seeking settlement, and the conditions in regards to their Employment Service Period and/ or GF Membership Period lengths upon which their eligible Settlement amounts (in percentages of balance) are calculated in alignment to GF Trust Deed. 
                                    </div>
                                </div>
                                <div class="col-8 approve-level-content">
                                    <gf-reasons-for-separation></gf-reasons-for-separation>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['companyid', 'pageurl'],

    data() {
        return {
            company_id: this.companyid,
        };
    },
    // No fdata/save logic needed here — <gf-reasons-for-separation> manages its
    // own list (fetch/add/edit/delete) independently, same as it did inside the
    // original combined GfSettings.vue component.
};
</script>